var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gondola__container",staticClass:"gondola__container"},[_c('div',{staticClass:"gondola",class:`gondola-${_vm.index}`,style:({
      left: _vm.leftPos,
      bottom: `${_vm.siblingHeight}px`,
      width: `${_vm.gondolaSize}px`,
      height: `${_vm.gondolaSize * 0.75}px`,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }